function updateCart () {
  toggleCartLoader();
  var cart = document.querySelector('#cart-main');
  var cart_ajax = document.querySelector('#cart-main-ajax');
  var formData = {};
  var formDataAttr = {};
  for (let index = 0; index < cart.elements.length; index++) {
    const element = cart.elements[index];
    if (element.name == 'updates[]') {
      formData[parseInt(element.dataset.key)] = parseInt(element.value);
    }
    if (element.name.includes("attributes[")) {
      var key = element.name.substring(
        element.name.indexOf("[") + 1, 
        element.name.lastIndexOf("]")
      );
      if (element.type == 'checkbox') {
        if (element.checked) {
          formDataAttr[key] = element.value;
        } else {
          formDataAttr[key] = null;
        }
      } else if (element.type == 'radio') {
        if (element.checked) {
          formDataAttr[key] = element.value;
        }
      } else {
        formDataAttr[key] = element.value;
      }
    }
  }
  formDataJSON = {
    updates: formData,
    attributes: formDataAttr,
    note: ''
  };
  //console.log(formDataAttr);
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formDataJSON),
  }).then(function(){
    refreshCart();
  })
  .catch(function(error) { 
    console.warn('Something went wrong.', error);
  });
}

function refreshCart(callback) {
  var cart = document.querySelector('#cart-main');
  var cart_ajax = document.querySelector('#cart-main-ajax');
  fetch('/cart?view=ajax-mini').then(function (response) {
    return response.text();
  }).then(function (html) {
    var parser = new DOMParser();
    var cartHTML = parser.parseFromString(html, 'text/html');
    cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
    if (cartHTML.querySelector('#cart-count')) {
      var cart_count = cartHTML.querySelector('#cart-count').innerHTML;
      var cart_counters = document.querySelectorAll('.cart-item-count');
      cart_counters.forEach((cart_counter) => {
        cart_counter.innerHTML = cart_count;
        if (cart_count == 0) {
          cart_counter.classList.add('d-none');
        } else {
          cart_counter.classList.remove('d-none');
        }
      });
    }
    if (cart) { // if main cart page
      fetch('/cart?view=ajax').then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var cartHTML = parser.parseFromString(html, 'text/html');
        cart.innerHTML = cartHTML.querySelector('body').innerHTML;
        toggleCartLoader();
        bind_inputs();
        setTimeout(summer_shipping(), 500);
      }).catch(function (error) {
        console.warn('Something went wrong.', error);
      });
    } else {
      toggleCartLoader();
    }
    if (typeof callback === "function") {
      callback();
    }
  }).catch(function (error) {
    console.warn('Something went wrong.', error);
  });
}

function toggleCartLoader() {
  var el = document.querySelector('.cart-loader');
  if (el.style.display == "none") {
    el.style.display = "flex";
  } else {
    el.style.display = "none";
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function predictive_search() {
  var inputs = document.querySelectorAll('[name="q"]');
  const predictiveSearchSection = document.querySelector('#predictive-results');
  var requestResponse;
  //on keyup, start the countdown
  inputs.forEach(input => {
    input.addEventListener('input', debounce((event) => {
      predictiveSearchSection.style.display = 'block';
      predictiveSearchSection.innerHTML = '<div class="mx-auto my-3 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
      var search_term = input.value;
      if (input.value != '') {
        fetch('/search/suggest?q='+search_term+'&resources[type]=product,collection,article,page,query&resources[limit]=10&section_id=site-predictive-search').then((response) => {
          requestResponse = response;
          return response.text();
        })
        .then((text) => {
          if (!requestResponse.ok) {
            console.error(requestResponse.status + ': ' + text);
          }
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-site-predictive-search').innerHTML;
            document.body.classList.add('overflow-hidden', 'vh-100');
          predictiveSearchSection.innerHTML = resultsMarkup;
        })
        .catch((error) => {
          console.error(error);
        });
      } else {
        predictiveSearchSection.style.display = 'none';
        document.body.classList.remove('overflow-hidden', 'vh-100');
      }
    }, 500));
    input.addEventListener('focus', debounce((event) => {
      predictiveSearchSection.style.display = 'block';
      document.body.classList.add('overflow-hidden', 'vh-100');
    }, 500));
    input.addEventListener('blur', debounce((event) => {
      if (input.value == '') {
        predictiveSearchSection.style.display = 'none';
        document.body.classList.remove('overflow-hidden', 'vh-100');
      }
    }, 500));
  });

  const history = getCookie('search_history');
  if (history) {
    const terms = history.split('|');
    const recent_searches_container = document.getElementById('recent-searches');
    if (recent_searches_container) {
      recent_searches_container.innerHTML = `
        <p class="my-0 pt-4 pb-2 mt-3 text-uppercase fw-semibold">Recent Searches <a href="#" id="clear-search-history" class="text-decoration-none text-capitalize ps-2">Clear</a></p>
        <ul class="list-unstyled p-0 m-0">
          ${terms.map(term => `<li class="py-1"><a class="text-decoration-none text-body text-capitalize" href="/search?q=${term}">${term}</a></li>`).join('')}
        </ul>
      `;
      const clearBtn = document.getElementById('clear-search-history');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          setCookie('search_history', null);
          recent_searches_container.innerHTML = '';
        });
      }
    }
  }
  
};

function ajaxAddToCart (e) {
  e.preventDefault();
  toggleCartLoader();
  console.log(e);
  var variant_id = e.target.getAttribute('data-variant');
  console.log(variant_id);
  let formData = {
    items: [{
     'id': variant_id,
     'quantity': 1
     }]
   };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(function(){
    refreshCart();
  }).catch((error) => {
    console.error('Error:', error);
  });
}
function ajaxRemoveFromCart (e) {
  e.preventDefault();
  toggleCartLoader();
  console.log(e);
  var key = e.target.getAttribute('data-key');
  console.log(key);
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({'id': key,'quantity': 0})
  }).then(function(){
    refreshCart();
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function bind_inputs() {
  Array.prototype.slice.call(document.querySelectorAll('.quantity-container')).map(function (container) {
    return {
      input: container.querySelector('.quantity-amount'),
      decrease: container.querySelector('.quantity-decrease'),
      increase: container.querySelector('.quantity-increase'),
      timer: null, // ← add timer per item
      get value () { return parseInt(this.input.value); },
      set value (v) { this.input.value = v; }
    }
  }).forEach(function (item) {
    function debounceChange() {
      clearTimeout(item.timer);
      item.timer = setTimeout(function(){
        item.input.closest('form').dispatchEvent(new Event('change', { bubbles: true }));
      }, 1000); // adjust delay as needed
    }
    item.decrease.onclick = function () { 
      item.value -= 1;
      if (item.value < item.input.min) {
        item.value = item.input.min;
      }
      debounceChange();
    };
    item.increase.onclick = function () { 
      item.value += 1;
      if (item.value > item.input.max) {
        item.value = item.input.max;
      }
      debounceChange();
    };
  });
  let addToCartButton = document.querySelectorAll('a.add-to-cart');
  for (let i = 0; i < addToCartButton.length; i++) {
    if (addToCartButton[i]) {
      if (addToCartButton[i].attachEvent) {
        addToCartButton[i].attachEvent("click", ajaxAddToCart);
      } else {
        addToCartButton[i].addEventListener("click", ajaxAddToCart);
      }
    }
  }
  let removeFromCartButton = document.querySelectorAll('a.remove-from-cart');
  for (let i = 0; i < removeFromCartButton.length; i++) {
    if (removeFromCartButton[i]) {
      if (removeFromCartButton[i].attachEvent) {
        removeFromCartButton[i].attachEvent("click", ajaxRemoveFromCart);
      } else {
        removeFromCartButton[i].addEventListener("click", ajaxRemoveFromCart);
      }
    }
  }
  let forms = document.querySelectorAll('form[action$="/cart/add"]');
	[].forEach.call(forms, function(form) {
		if (form) {
			if (form.attachEvent) {
				form.attachEvent("submit", addProductToCart);
			} else {
				form.addEventListener("submit", addProductToCart);
			}
		}
	});

  var checkbox = document.getElementById('delivery-target');
  var checkboxFields = document.getElementById('dateInputCollapse');
  if (checkbox) {
    var checkboxFieldsOBJ = new bootstrap.Collapse(checkboxFields, { toggle: false })
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        checkboxFieldsOBJ.show();
        document.querySelector('#deliver-on-target-date').value = null;
        console.log('Open');
      } else {
        console.log('Close');
        checkboxFieldsOBJ.hide();
        document.querySelector('#deliver-on-target-date').value = null;
      }
    });
  }
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

function addProductToCart(e) {
  e.preventDefault();
  toggleCartLoader();
  let addToCartForm = e.target;
  let formData = new FormData(addToCartForm);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  }).then(function(){
    refreshCart(() => {
      document.querySelectorAll(".cart-toggle").forEach(el => {
        el.classList.add("open");
      });
      setTimeout(() => {
        document.querySelectorAll(".cart-toggle").forEach(el => {
          el.classList.remove("open");
        });
      }, 3000);
    });
  }).catch((error) => {
    console.error('Error:', error);
  });
}

window.addEventListener("load", function () {
  var _learnq = _learnq || [];
  predictive_search();
  bind_inputs();
  summer_shipping();
  track_recently_viewed();
  read_toggle();
  quick_shop_modal();
  var cart = document.querySelector('#cart-main');
  if (cart) {
    cart.addEventListener('change', function(event){
      //console.log(event.target.id);
      if (event.target.name == 'updates[]' || event.target.id == 'cart-main' ) {
        updateCart();
      }
    });
  }
});

function read_toggle () {
  document.querySelectorAll('.read-toggle').forEach(button => {
    const text = button.previousElementSibling;
    if (text.scrollHeight == text.clientHeight) { // check if text is clamped. If not, hide read more button
      console.log(text.scrollHeight + ' : ' + text.clientHeight);
      text.classList.toggle('expanded');
      button.classList.add('d-none');
    }
    button.addEventListener('click', function () {
      const text = this.previousElementSibling;
      const isExpanded = text.classList.toggle('expanded');
      this.textContent = isExpanded ? 'Read less' : 'Read more';
    });
  });
}

function track_recently_viewed () {
  var product_container = document.getElementById('product-container');
  if (product_container) {
    var handle = product_container.getAttribute('data-product-handle');
    if (!getCookie('recently_viewed')) {
      setCookie('recently_viewed', JSON.stringify([]), 90);
    }
    var items = JSON.parse(getCookie('recently_viewed'));
    var index = items.indexOf(handle);
    if (index == -1) {
      items.push(handle);
      var items_json = JSON.stringify(items)
      setCookie('recently_viewed', items_json, 90);
    }
  }
}

function quick_shop_modal () {
  document.addEventListener('click', function (e) {
    const button = e.target.closest('button[data-bs-toggle="modal"][data-product]');
    if (!button) return;

    e.preventDefault();

    const productUrl = button.getAttribute('data-product');
    const modalId = button.getAttribute('data-bs-target');
    const modal = document.querySelector(modalId);
    const modalBody = modal.querySelector('.modal-body');

    modalBody.innerHTML = '<div style="padding: 2rem; text-align: center;">Loading...</div>';

    fetch(productUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        modalBody.innerHTML = html;

        const navSwiperEl = modalBody.querySelector('#quick-shop-product-navigation-swiper .swiper');
        const mainSwiperEl = modalBody.querySelector('#quick-shop-product-main-swiper .swiper');

        const product_navigation_swiper = new Swiper(navSwiperEl, {
          loop: false,
          autoplay: false,
          disableOnInteraction: false,
          slidesPerView: 4,
          spaceBetween: 16,
          watchSlidesProgress: true,
          watchOverflow: true
        });

        const product_main_swiper = new Swiper(mainSwiperEl, {
          loop: false,
          autoplay: false,
          disableOnInteraction: false,
          slidesPerView: 1,
          spaceBetween: 16,
          thumbs: {
            swiper: product_navigation_swiper
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        });

        const policyCheckbox = modalBody.querySelector('#policyCheck');
        const addToCartButtons = modalBody.querySelectorAll('form[action="/cart/add"] button[name="add"]');
        if (policyCheckbox) {
          policyCheckbox.addEventListener('change', function () {
            addToCartButtons.forEach(button => {
              button.disabled = !policyCheckbox.checked;
            });
          });
        }
        const radios = document.querySelectorAll('.variant-radio');
        const priceEl = document.querySelector('.variant-price');
        const unitPriceEl = document.querySelector('.variant-unit-price');
        const comparePriceEl = document.querySelector('.variant-compare-price');
        const selectedVariantEl = document.querySelector('.selected-variant');

        radios.forEach(radio => {
          radio.addEventListener('change', function () {
            const price = this.dataset.price;
            priceEl.textContent = price;
            if (comparePriceEl) {
              const compare_at_price = this.dataset.comparePrice;
              comparePriceEl.textContent = compare_at_price;
            }
            const unit_price = this.dataset.unitPrice;
            unitPriceEl.textContent = unit_price;
            const variant_name = this.dataset.name;
            selectedVariantEl.textContent = variant_name;

            document.querySelector('#quick-shop-id').value = this.value;
            
            if (typeof iWish !== 'undefined' && typeof iWish.checkIwishColl === 'function') {
              iWish.checkIwish(document.querySelector('#quick-shop-id'));
            }
          });
        });

        modalBody.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
          form.addEventListener("submit", function (e) {
            e.preventDefault();
            addProductToCart(e);
            const modalInstance = bootstrap.Modal.getInstance(modal);
            modal.addEventListener('hidden.bs.modal', function handler() {
              modal.removeEventListener('hidden.bs.modal', handler);
              //window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
            });
            modalInstance.hide();
          });
        });
      })
      .catch(error => {
        modalBody.innerHTML = `<div style="color: red; padding: 2rem;">Failed to load content.</div>`;
        console.error('Error loading modal content:', error);
      });
  });
}

function summer_shipping () {
  const summerEl = document.getElementById("summer-shipping");
  if (!summerEl) return;

  const hasChocolate = summerEl.dataset.chocolatePresent === "true";
  const missingSummerShipping = summerEl.dataset.missingSummerShip === "true";
  const productId = parseInt(summerEl.dataset.productId);
  const variantId = parseInt(summerEl.dataset.variantId);

  function updateSummerShip(updates, callback) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(callback)
    .catch(console.error);
  }

  if (hasChocolate && missingSummerShipping) {
    console.log("Summer shipping is missing — adding it...");
    updateSummerShip({ [variantId]: 1 }, () => {
      toggleCartLoader();
      refreshCart();
    });
  } else if (!hasChocolate) {
    console.log("No chocolate detected — removing summer shipping if present...");
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const originalCount = cart.item_count;
        updateSummerShip({ [variantId]: 0 }, (updatedCart) => {
          if (updatedCart.item_count !== originalCount) {
            toggleCartLoader();
            refreshCart();
          }
        });
      });
  }
}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}